export default __webpack_public_path__ + "static/media/yw-icons.1e89da2f.woff2";